import { useQuery } from 'react-query';

import { getSRBMDetail } from 'api/traps/SRBMTraps/getSRBMDetail';

export const useGetSRBMDetail = (slug: string) => {
  const { data, refetch, isLoading } = useQuery('GetSRBMDetail', () => getSRBMDetail(slug), {
    refetchOnWindowFocus: false,
  });

  return { data, refetch, isLoading };
};

export default useGetSRBMDetail;
